import React from 'react';
import isNewConsumerApp from 'commons/isNewConsumerApp';

/**
 * A compatibility wrapper for useTransition that works in both React 17 and 18.
 * In React 18 (new consumer app), it uses the native useTransition.
 * In React 17 (legacy), it returns a no-op startTransition that executes callbacks immediately.
 *
 * @returns {[boolean, function]} - [isPending, startTransition]
 */
export const useTransition = () => {
  // React 18+ with useTransition available
  if (isNewConsumerApp && typeof React.useTransition === 'function') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return React.useTransition();
  }

  // Fallback for React 17 / Node 14 - execute the callback immediately
  const startTransition = callback => {
    callback();
  };

  return [false, startTransition];
};

/**
 * A compatibility wrapper for useDeferredValue that works in both React 17 and 18.
 * In React 18 (new consumer app), it uses the native useDeferredValue.
 * In React 17 (legacy), it returns the value directly (no deferral).
 *
 * @param {any} value - The value to defer
 * @returns {any} - The deferred value (or the same value in React 17)
 */
export const useDeferredValue = value => {
  // React 18+ with useDeferredValue available
  if (isNewConsumerApp && typeof React.useDeferredValue === 'function') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return React.useDeferredValue(value);
  }

  // Fallback for React 17 / Node 14 - return the value directly (no deferral)
  return value;
};
